import { PLAN_ICON_MAPPER } from '@/constants';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatCurrency } from '@/helpers/formatters';
import { ArrowRight, Check, Sparkles, X } from 'lucide-react';
import React from 'react';
import { Button } from '../ui/button';

function PlanDetailsCard({ plan, planMode, selectedPlan, onPlanSelect }) {

    const planName = String(plan?.name).toLocaleLowerCase().replace(" ", "")
    const Icon = planMode === "subscription"
        ? PLAN_ICON_MAPPER[planName] || Sparkles
        : PLAN_ICON_MAPPER[planName.toLocaleLowerCase()] || Sparkles || Sparkles;

    const isSelected = selectedPlan === plan?.id;

    const price = formatCurrency(plan?.amount, plan?.currency)

    return (
        <Card
            key={plan?.id}
            onClick={() => {
                onPlanSelect(plan?.id)
            }}
            className={`relative flex flex-col w-[400px] cursor-pointer transition-all duration-200
    ${isSelected
                    ? "border-primary shadow-xl shadow-primary/10 scale-[1.02]"
                    : "border-border hover:border-primary/50"
                }`}
        >

            {plan?.recommended && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <Badge className="bg-purple-500 text-white px-4 py-1">
                        {plan?.recommended_text || "Recommended"}
                    </Badge>
                </div>
            )}

            {plan?.offers?.is_offer && (
                <div className="absolute top-6 left-6">
                    <Badge className="bg-orange-500 text-white px-2 py-1 text-xs font-semibold">
                        {plan?.offers?.offer_percent}% OFF
                    </Badge>
                </div>
            )}

            {/* Selected indicator */}
            <div className="absolute top-4 right-4">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${isSelected
                    ? "border-primary bg-primary"
                    : "border-muted-foreground/30"
                    }`}>
                    {isSelected && <Check className="w-3 h-3 text-white" />}
                </div>
            </div>

            <CardHeader className="text-center pb-4">

                {/* Icon */}
                <div className="w-12 h-12 rounded-xl mx-auto mb-4 flex items-center justify-center bg-primary/10">
                    <Icon className="w-6 h-6 text-primary" />
                </div>

                <CardTitle className="text-xl">{plan?.name}</CardTitle>

                {plan?.description && (
                    <CardDescription>{plan?.description}</CardDescription>
                )}

            </CardHeader>

            <CardContent className="flex flex-col flex-1">

                {/* Price */}
                <div className="text-center mb-6">
                    <div className="flex flex-col items-center gap-1">

                        {/* Discounted Price */}
                        <div className="flex items-baseline gap-2">
                            <span className="text-4xl font-bold">
                                {formatCurrency(
                                    plan?.offers?.is_offer ? plan?.offers?.offer_price : plan?.amount,
                                    plan?.currency
                                )}
                            </span>

                            <span className="text-muted-foreground text-sm">
                                /{plan?.period}
                            </span>
                        </div>

                        {/* Original Price (only if offer exists) */}
                        {plan?.offers?.is_offer && (
                            <span className="text-lg text-muted-foreground line-through">
                                {formatCurrency(plan?.amount, plan?.currency)}
                            </span>
                        )}
                    </div>
                </div>

                {/* Features */}
                <ul className="space-y-3 mb-6 flex-1">
                    {plan?.features?.map((feature, index) => (
                        <li key={index} className="flex items-start gap-3 text-sm">
                            <Check className={`w-4 h-4 flex-shrink-0 mt-0.5 ${plan?.color === 'purple' ? 'text-purple-500' : 'text-blue-500'
                                }`} />
                            <span>{feature}</span>
                        </li>
                    ))}
                    {plan?.excluded_features?.map((feature, idx) => (
                        <li key={`ex-${idx}`} className="flex items-start gap-3 text-sm">
                            <X className="w-4 h-4 flex-shrink-0 mt-0.5 text-red-400" />
                            <span className="text-muted-foreground/60 line-through">{feature}</span>
                        </li>
                    ))}
                </ul>

                {/* <Button
                    size="lg"
                    // disabled={isSelected}
                    className={`w-full group border border-blue-600 ${isSelected
                        ? "bg-blue-900 text-white"
                        : "bg-white text-black hover:bg-blue-50"
                        }`}
                >
                    {isSelected ? "Selected" : "Select"}

                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                </Button> */}

            </CardContent>
        </Card>
    );
}

export default PlanDetailsCard;